import { render, staticRenderFns } from "./ChangelogView.vue?vue&type=template&id=c3e86a90&scoped=true&"
import script from "./ChangelogView.vue?vue&type=script&lang=js&"
export * from "./ChangelogView.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogView.vue?vue&type=style&index=0&id=c3e86a90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e86a90",
  null
  
)

export default component.exports